import {Component, OnInit,
  CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {ConfiguratorProductService} from '@app/product/configurator/services/configurator-product.service';
import {Observable} from 'rxjs';
import {map, tap} from 'rxjs/operators';
import {DcpProductDataService} from '@app/product/data/dcp-product-data.service';
import {RenewalType, IconButtonTooltipComponent} from '@dcp/configurator';
import {FieldType} from '@ngx-formly/core';
import {TranslatePipe} from '@spartacus/core';
import {AsyncPipe} from '@angular/common';

@Component({
  selector: 'dcp-renewal',
  templateUrl: './renewal.component.html',
  imports: [IconButtonTooltipComponent, TranslatePipe, AsyncPipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class FormlyRenewalComponent extends FieldType implements OnInit {
  public renewalTypes$: Observable<RenewalType[]>;

  constructor(
    private configuratorProductService: ConfiguratorProductService,
    private productDataService: DcpProductDataService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.renewalTypes$ = this.getRenewalTypes();
  }

  /**
   * Gets the renewalTypes for the current VariantProduct by parsing the json data
   * or return [] when data is not set or renewalType is []
   *
   * @return Observable<RenewalType[]> an Observable containing the RenewalTypes as an array
   */
  private getRenewalTypes(): Observable<RenewalType[]> {
    return this.configuratorProductService.getVariant$().pipe(
      map((product) => this.productDataService.getRenewalTypes(product?.data) || []),
      tap((rts) => {
        const rt = rts.find((rt) => rt.value === 'auto');
        if (rt) {
          this.formControl.setValue(rt.value);
        }
      }),
    );
  }
}
